// HT-4.5 · 読み直しの履歴（監査記録から作成。自動での読み直しはありません）
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { LEARN, authHeader, detailOf, Pill, Empty, Collapse } from './shared';

export default function RereadHistory({ reloadKey }) {
  const [d, setD] = useState(null);
  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${LEARN}/reread-history`, { headers: authHeader() });
      setD(r.data);
    } catch (e) { setD({ rows: [], error_ja: detailOf(e, '履歴を取得できませんでした') }); }
  }, []);
  useEffect(() => { load(); }, [load, reloadKey]);

  if (!d) return null;
  return (
    <div className="pt-3">
      <Collapse label={`読み直しの履歴（${d.count ?? 0}回）`} testId="reread-history">
        {d.error_ja && (
          <p className="text-[11.5px] text-amber-900" data-testid="reread-history-error">
            {d.error_ja}
          </p>
        )}
        {(d.rows || []).length === 0 ? (
          <Empty testId="reread-history-empty">読み直しの実行履歴はまだありません。</Empty>
        ) : (
          <div className="space-y-1.5">
            {(d.rows || []).map((r) => (
              <div key={`${r.at}-${r.by}`} className="rounded-md border border-zinc-200 px-2.5 py-2"
                data-testid={`reread-history-run-${r.at}`}>
                <p className="flex flex-wrap items-center gap-1.5">
                  <Pill tone={r.failed ? 'amber' : 'teal'}>
                    {String(r.at).slice(0, 16).replace('T', ' ')}
                  </Pill>
                  <span className="text-[11.5px] text-zinc-700">{r.by}</span>
                  {r.learning_version && <Pill>バージョン {r.learning_version}</Pill>}
                  <span className="text-[11.5px] text-zinc-600">{r.summary_ja}</span>
                </p>
                {(r.documents || []).map((x) => (
                  <p key={x.document_id} className="pt-0.5 text-[11px] text-zinc-600">
                    {x.ok ? '○' : '×'} {x.title || x.document_id}
                    {x.ok
                      ? `（学習内容の適用 ${x.applied_count}件${
                        (x.effects_ja || []).length ? `: ${x.effects_ja.join(' / ')}` : ''}）`
                      : `（${x.error_ja || '理由の記録がありません'}）`}
                  </p>
                ))}
              </div>
            ))}
          </div>
        )}
        <p className="pt-1.5 text-[11px] text-zinc-500">{d.notice_ja}</p>
      </Collapse>
    </div>
  );
}
